/**
 *
 * Garage
 *
 */
import NoPermissionsCard from 'app/components/NoPermissionsCard/NoPermissionsCard';
import { RouteConstants } from 'app/routes';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { selectPermissions } from '../Authorization/slice/selectors';
import EmployeeDetailsPage from './pages/EmployeeDetailsPage/EmployeeDetailsPage';
import GaragePage from './pages/GaragePage/GaragePage';
import ImplementDetailsPage from './pages/ImplementDetailsPage/ImplementDetailsPage';
import TransportDetailsPage from './pages/TransportDetailsPage/TransportDetailsPage';

interface IProps extends RouteComponentProps {}

const Garage: FC<IProps> = props => {
  const { garageAdministration } = useSelector(selectPermissions);
  if (garageAdministration === 0) {
    return <NoPermissionsCard />;
  }

  return (
    <Switch>
      <Route
        exact
        path={RouteConstants.garage.transportList}
        component={GaragePage}
      />
      <Route
        exact
        path={RouteConstants.garage.implementList}
        component={GaragePage}
      />
      <Route
        exact
        path={RouteConstants.garage.employeeList}
        component={GaragePage}
      />

      <Route
        path={RouteConstants.garage.transportDetails}
        component={TransportDetailsPage}
      />
      <Route
        path={RouteConstants.garage.implementDetails}
        component={ImplementDetailsPage}
      />
      <Route
        path={RouteConstants.garage.employeeDetails}
        component={EmployeeDetailsPage}
      />

      <Redirect
        exact
        from={RouteConstants.garage.index}
        to={RouteConstants.garage.transportList}
      />
    </Switch>
  );
};

export default Garage;
